export function removeVendorPrefix(val) {
    return val.replace(/^-(webkit|moz|ms|o)-/, "");
}
export default removeVendorPrefix;

//# sourceMappingURL=removeVendorPrefix.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/removeVendorPrefix.js
// module id = 232
// module chunks = 0